module.exports = __webpack_public_path__ + "static/media/file-upload.bcff1505.svg";